/**
 * Values opened in this tab, by secret id. The server erases a secret on opening, so the
 * plaintext must survive anything that remounts the card (a refetch, a re-render) until
 * the person closes the window: it lives here, not in component state.
 */
export const openedValues = new Map<string, string>();

/** Was this secret opened in this tab (its value is still held for «Показать ещё раз»)? */
export const hasOpenedValue = (id: string) => openedValues.has(id);
